import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
var deleteUserAvatar = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_, args, context) {
    var userId, url;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          userId = args.userId;
          url = "".concat(context.url.stargateRoot, "/users/").concat(userId, "/manage/avatar");
          return _context.abrupt("return", context.fetch(url, {
            method: 'DELETE'
          }).then(function () {
            return true;
          }));
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function deleteUserAvatar(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export default deleteUserAvatar;